import React, { Component } from 'react';
import qs from 'qs';

import { Inactive } from '../components';

class InactivePage extends Component {
  queryString(key) {
    return qs.parse(this.props.location.search.substr(1))[key];
  }

  render() {
    return (
      <div>
        <Inactive block={!!this.queryString('block')} />
      </div>
    );
  }
}

export default InactivePage;
